import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Legacy `/detail/:id` compatibility redirect (container-view 06): old
 * bookmarks, previous snackbar destinations and back targets land on the merged
 * container page.
 *
 * The redirect **replaces** the history entry, so a saved legacy link cannot
 * bounce forward again. The query string and `location.state` survive, which
 * keeps the back contract working when the legacy URL was opened from search or
 * a scan.
 */
export function DetailRedirect() {
  const { selectedId } = useParams<{ selectedId: string }>();
  const location = useLocation();

  return (
    <Navigate
      to={{
        pathname: `/browse/${selectedId}`,
        search: location.search,
        hash: location.hash,
      }}
      replace
      state={location.state}
    />
  );
}
